import api from '../axios';

export const GET_ALL_RAFFLES = 'GET_ALL_RAFFLES'

export const getAllRaffles = (token) => (dispatch) => {
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ` + token,
        },
    };
    return api.get('/raffles' + '?size=300', options)
        .then((response) => {
            dispatch({ type: GET_ALL_RAFFLES, payload: response.data})
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}
